import React, { InputHTMLAttributes } from 'react';

import { Container, Input, Label, AdditionalInformation } from './inputField.styles';

export interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  nameSuffix?: string;
  className?: string;
  name: string;
  label: string;
  additionalInformation?: string;
  disabled?: boolean;
}

export const InputField = ({
  nameSuffix = '',
  className,
  name,
  label,
  additionalInformation,
  disabled = false,
  type = 'text',
  ...restProps
}: InputFieldProps) => {
  const id = `${name}${nameSuffix}`;
  return (
    <Container className={className}>
      <Label htmlFor={id}>{label}</Label>
      <AdditionalInformation>{additionalInformation}</AdditionalInformation>
      <Input id={id} name={name} disabled={disabled} {...restProps} />
    </Container>
  );
};
